// extracted by mini-css-extract-plugin
module.exports = {"list":"SearchStrategyResult_list__1D7q7","emptyBox":"SearchStrategyResult_emptyBox__OplO6","description":"SearchStrategyResult_description__evIII"};